import type { BlotterType } from 'models/blotters/BlotterType';
import type { IBlotterItem, IBlotterProductItem } from 'models/IBlotterItem';
import { DlpProductBlotterItem, DlpProductTradeItem } from 'state/blotters/trades/types/blotterItem';

const QUOTE_BLOTTER_PANEL_FIELDS_NAME = [
  'externalQuoteId',
  'pricerRfqId',
  'user',
  'selectedOnBehalfClient',
  'mode',
  'status',
  'productCode',
  'currency',
  'notional',
  'underlyings',
  'maturityDate',
  'solveFor',
  'quoteResult',
  'xMargin',
  'strike',
  'coupon',
  'couponBarrier',
  'recallCoupon',
  'recallThreshold',
  'kiThreshold',
  'wrapper',
  'isPrivateMode',
  'upfrontFee',
  'quoteDate',
  'productId',
];

const TRADE_BLOTTER_PANEL_FIELDS_NAME = [
  'tradeDate',
  'externalQuoteId',
  'isin',
  'fileCode',
  'user',
  'selectedOnBehalfClient',
  'status',
  'creditCheckStatus',
  'productCode',
  'currency',
  'notional',
  'underlyings',
  'settlementPrice',
  'upFrontFee',
  'xMargin',
  'maturityDate',
  'strike',
  'coupon',
  'couponBarrier',
  'recallCoupon',
  'recallThreshold',
  'kiThreshold',
  'wrapper',
  'createdOn',
  'productId',
];

const PRODUCT_BLOTTER_PANEL_FIELDS_NAME: (keyof IBlotterProductItem | keyof IBlotterItem | string)[] = [
  'productId',
  'assetType',
  'product',
  'productSubType',
  'productStatus',
  'sales',
  'isin',
  'fileCode',
  'productWrapper',
  'underlyings',
  'issueSize',
  'currency',
  'launchDate',
  'strikeDate',
  'issueDate',
  'maturityDate',
  'hasPublicOffering',
  'offeringStartDate',
  'offeringEndDate',
  'termSheetStatus',
  'finalTermsStatus',
  'coupon',
  'couponBarrier',
  'couponFrequency',
  'instrumentName',
  'instrumentContractName',
  'kiBarrier',
  'kiBarrierType',
  'lastUpdate',
  'recallBarrier',
  'recallCoupon',
  'strike',
  'settlementType',
  'client',
];

const DLP_PRODUCTS_BLOTTER_PANEL_FIELDS_NAME: (keyof DlpProductBlotterItem)[] = [
  'pricerRfqId',
  'isin',
  'client',
  'productType',
  'productSubType',
  'wrapper',
  'status',
  'underlying',
  'currency',
  'issueSize',
  'strike',
  'strikeToday',
  'barrier',
  'barrierToday',
  'optionStyle',
  'distributorUpFront',
];

const DLP_PRODUCTS_TRADES_BLOTTER_PANEL_FIELDS_NAME: (keyof DlpProductTradeItem)[] = [
  'productIsin',
  'tradeReference',
  'tradeSide',
  'status',
  'quantity',
  'orderType',
  'custodian',
];
export function getBlotterPanelFieldNames(blotterType: BlotterType): string[] {
  switch (blotterType) {
    case 'quotes':
      return QUOTE_BLOTTER_PANEL_FIELDS_NAME;
    case 'trades':
      return TRADE_BLOTTER_PANEL_FIELDS_NAME;
    case 'products':
      return PRODUCT_BLOTTER_PANEL_FIELDS_NAME;
    case 'dlpProducts':
      return DLP_PRODUCTS_BLOTTER_PANEL_FIELDS_NAME;
    case 'dlpProductTrades':
      return DLP_PRODUCTS_TRADES_BLOTTER_PANEL_FIELDS_NAME;
    default:
      return [];
  }
}
